__turbopack_context__.v({
  "blocksBackgroundColor": "LinksTerrace-module-scss-module__hI0y7a__blocksBackgroundColor",
  "blocksFontColor": "LinksTerrace-module-scss-module__hI0y7a__blocksFontColor",
  "childSlideContainerMobile": "LinksTerrace-module-scss-module__hI0y7a__childSlideContainerMobile",
  "cleverSliderContainer": "LinksTerrace-module-scss-module__hI0y7a__cleverSliderContainer",
  "container": "LinksTerrace-module-scss-module__hI0y7a__container",
  "scrollArrow": "LinksTerrace-module-scss-module__hI0y7a__scrollArrow",
  "secondaryNavBackgroundColor": "LinksTerrace-module-scss-module__hI0y7a__secondaryNavBackgroundColor",
  "slideItem": "LinksTerrace-module-scss-module__hI0y7a__slideItem",
  "slideItemScrollArea": "LinksTerrace-module-scss-module__hI0y7a__slideItemScrollArea",
  "themeBackgroundColor": "LinksTerrace-module-scss-module__hI0y7a__themeBackgroundColor",
  "themeFontColor": "LinksTerrace-module-scss-module__hI0y7a__themeFontColor",
  "themeFontFamily": "LinksTerrace-module-scss-module__hI0y7a__themeFontFamily",
});
